import { Box, Grid2, Typography } from "@mui/material";
import React from "react";

const ViewBidOpeners = ({ tender }) => {
  return (
    <Box className="dashboard-container" px={10}>
      <Typography variant="h6">Bid Openers</Typography>

      <Grid2 container>
        <Grid2 size={{ xs: 12, sm: 12 }} className="preview-grid" sx={{borderTop: '1px solid #000', borderRight: '1px solid #000'}}>
          Total Bid Openers: {tender.openers ? tender.openers[0].noOfOpeners : 0}
        </Grid2>
        {tender ?
          tender.openers.map((opener, i) => (
            <React.Fragment key={i}>
              <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                Bid Openers
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid" sx={{borderRight: '1px solid #000'}}>
                {opener.opener.name}
              </Grid2>
            </React.Fragment>
          )) : null}
      </Grid2>
    </Box>
  );
};

export default ViewBidOpeners;
